let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("as200")).then(() => parcelRequire('j6Qxa'));